import React, { useEffect, useState } from 'react';
import Icons from '../../../configs/icon.config';

function ScrollDown() {
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const position = window.scrollY;
      setScrollPosition(position);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const autoScroll = () => {
    window.scrollTo({
      top: 500,
      behavior: 'smooth', // Add smooth scrolling animation
    });
  };

  return (
    <div>
      {scrollPosition <= 0 && (
        <button
          className="scroll"
          onClick={() => {
            setScrollPosition(1);
          }}
        >
          <span
            className="icons animate-bounce cursor-pointer"
            onClick={autoScroll}
          >
            {Icons.downArrow}
          </span>
        </button>
      )}
    </div>
  );
}

export default React.memo(ScrollDown);
